import { getPushConfig, micrositeConfigSave, getApprovalConfig, micrositeApprovalSave } from '../../services/webSiteSetUp/webSiteSetUp';

const initState = {};

export default {
  namespace: 'webSiteSetUp',
  state: initState,
  effects: {
    *fetchMicrositeConfigSave({ params }, { call }) {
      try {
        const response = yield call(micrositeConfigSave, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchPushConfigInfo({ params }, { call }) {
      try {
        const response = yield call(getPushConfig, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchApprovalConfigInfo({ params }, { call }) {
      try {
        const response = yield call(getApprovalConfig, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchApprovalConfigSave({ params }, { call }) {
      try {
        const response = yield call(micrositeApprovalSave, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
